import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getVariantChildrenDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import getColor from "@insite/mobius/utilities/getColor";
import GuestQuoteRequestForm from "@ucs/Components/GuestRequestForm/GuestQuoteRequestForm";
import ProductGetQuote from "@ucs/Components/ProductDetails/ProductGetQuote";
import UCSColors from "@ucs/Utils/UCSColors";
import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    overrideButtonText = "overrideButtonText",
}

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => ({
    configurationSelection: state.pages.productDetails.configurationSelection,
    configurationCompleted: state.pages.productDetails.configurationCompleted,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    userRoles: state.context.session!.userRoles,
    isAuthenticated: state.context.session!.isAuthenticated,
    state,
});

export interface ProductDetailsAddToCartButtonStyles {
    button?: ButtonPresentationProps;
}

export const addToCartButtonStyles: ProductDetailsAddToCartButtonStyles = {
    button: {
        css: css`
            width: 100%;
            background-color: white;
            border: 2px solid ${getColor("primary")};
            color: ${UCSColors.gray03};
            &:hover {
                color: white;
            }
        `,
    },
};

const styles = addToCartButtonStyles;

const ProductDetailsGetQuoteButton = ({
    configurationSelection,
    configurationCompleted,
    variantSelectionCompleted,
    userRoles,
    isAuthenticated,
    product,
    state,
    fields,
}: Props) => {
    const [showQuoteModal, setShowQuoteModal] = useState(false);
    const variantChildren = getVariantChildrenDataView(state, product.id).value!;
    const isParentProduct = variantChildren && variantChildren.length > 0;
    
    return (
        <>
            {isAuthenticated &&
            (userRoles.toLowerCase().includes("vip") || userRoles.toLowerCase().includes("buyer")) ? (
                <ProductGetQuote
                    configurationSelection={configurationSelection}
                    configurationCompleted={configurationCompleted}
                    variantSelectionCompleted={variantSelectionCompleted}
                    extendedStyles={styles.button}
                    labelOverride={fields.overrideButtonText}
                    data-test-selector="addProductToCart"
                />
            ) : (
                !isAuthenticated &&
                (
                    <>
                        <Button disabled={isParentProduct} onClick={() => setShowQuoteModal(true)} {...styles.button}>
                            {fields.overrideButtonText}
                        </Button>
                        <GuestQuoteRequestForm
                            isModalOpen={showQuoteModal}
                            toggleModal={() => setShowQuoteModal(!showQuoteModal)}
                        />
                    </>
                )
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsGetQuoteButton)),
    definition: {
        displayName: "Get Quote Button",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.overrideButtonText,
                displayName: "Override Button Text",
                editorTemplate: "TextField",
                fieldType: "General",
                defaultValue: "Get Quote",
            },
        ],
    },
};

export default widgetModule;
